import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSolidChevronDown = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="m4.127 6.037 3.422 4.723c.199.276.563.32.812.1a.6.6 0 0 0 .09-.1l3.422-4.723a.684.684 0 0 0-.09-.897.55.55 0 0 0-.361-.14H4.578C4.258 5 4 5.286 4 5.638c0 .145.045.286.127.4"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSolidChevronDown);
export default ForwardRef;
